
  import '/Users/jilin/projects/antd/rc-dialog/assets/bootstrap.less?watch=parent';
  export default "@prefixCls: rc-dialog;\n@import \"./bootstrap/Dialog.less\";\n@import \"./index/Mask.less\";\n";;
  